export default [
	{
		name: "Spring Energy (Tanjong Quarry)",
		lat: 2.9594541752833945,
		lng: 101.56775173862977,
	},
	{
		name: "Spring Energy (Semenyih Quarry)",
		lat: 2.9812401398501702,
		lng: 101.83926633735034,
	},
	{
		name: "CSA Industries Sdn Bhd",
		lat: 3.083390,
		lng: 101.812836,
	},
	{
		name: "Spring Energy (Saujana Utama)",
		lat: 2.9587622247551275,
		lng: 101.56794175088585,
	},
	{
		name: "Kajang Rock (Semenyih)",
		lat: 2.9873916122593904,
		lng: 101.83599985397233,
	},
	{
		name: "Kajang Rock (KLIA)",
		lat: 2.7376126705998205,
		lng: 101.69829184601164,
	},
	{
		name: "CSA Premix",
		lat: 3.9226367415775583,
		lng: 100.95805989716672,
	},
	{
		name: "Sg Long Quarry",
		lat: 3.0759937378951183,
		lng: 101.81089818367026,
	},
	{
		name: "Swee Premix Sdn. Bhd",
		lat: 3.241883268509034,
		lng: 101.70510049907735,
	},
	{
		name: "Swee Quarry",
		lat: 3.3054715964764063,
		lng: 101.7432031125061,
	},
	{
		name: "Setia Premix Sdn Bhd",
		lat: 3.1078553676510547,
		lng: 101.39495209722759,
	},
	{
		name: "East Rock Marketing",
		lat: 3.176960,
		lng: 101.326109,
	},
	{
		name: "Hanson Quarry & Premix (Nilai)",
		lat: 2.786126764568544,
		lng: 101.83163191695886,
	},
	{
		name: "Hanson Quarry & Premix (Tanah Merah)",
		lat: 2.6524125622610732,
		lng: 101.82328031068344,
	},
	{
		name: "Hanson Quarry & Premix (Cheras)",
		lat: 3.0471636574641416,
		lng: 101.7778590413681,
	},
	{
		name: "Hanson Quarry & Premix (Sg. Buloh)",
		lat: 3.236918037540612,
		lng: 101.57381975116579,
	},
	{
		name: "Hanson Quarry & Premix (Bukit Raja)",
		lat: 3.1120341100997337,
		lng: 101.39764206835555,
	},
	{
		name: "Hanson Quarry & Premix (Hulu Langat)",
		lat: 3.060380054949669,
		lng: 101.82301752787447,
	},
	{
		name: "Sunway Quarry Industries Sdn. Bhd (Hulu Langat)",
		lat: 3.08333889,
		lng: 101.81695833,
	},
	{
		name: "Sunway Quarry Industries Sdn. Bhd (Rawang)",
		lat: 3.32541667,
		lng: 101.59909444,
	},
	{
		name: "Sunway Quarry Industries Sdn. Bhd (Semenyih)",
		lat: 2.97957778,
		lng: 101.85066667,
	},
	{
		name: "Blacktop Rawang",
		lat: 3.29995556,
		lng: 101.60659444,
	},
	{
		name: "Blacktop Sepang",
		lat: 2.81011667,
		lng: 101.64363333,
	},
	{
		name: "Hanson Quarry & Premix Rawang",
		lat: 3.2967063354151405,
		lng: 101.60192455013683,
	},
	{
		name: "Mersing Quarry Sdn Bhd (Sg Buloh) ",
		lat: 3.2530481517147916,
		lng: 101.57460162771449,
	},
]